__turbopack_context__.v({
  "className": "nexafont_610ee154-module__12Y7Ra__className",
  "variable": "nexafont_610ee154-module__12Y7Ra__variable",
});
